declare const productSiteRegion: string;
import { Injectable } from '@angular/core';
import { ProductSiteRegionEnum } from '@app/models/enums/product-site-region.enum';

@Injectable({providedIn: 'root'})
export class ProductSiteRegionService {
    getProductSiteRegion(): ProductSiteRegionEnum {

        if (ProductSiteRegionEnum[productSiteRegion]) {
            return ProductSiteRegionEnum[productSiteRegion];
        }

        return null;
    }

    isThermofisher(): boolean {
        return ProductSiteRegionEnum.THERMOFISHER === this.getProductSiteRegion();
    }

    isFisherSci(): boolean {
        return [ProductSiteRegionEnum.FISHERSCI_US, ProductSiteRegionEnum.FISHERSCI_CA, ProductSiteRegionEnum.FISHERSCI_EU].includes(this.getProductSiteRegion());
    }

}
